export const vaultsTableColumns = [
  'token',
  'protocol',
  'name',
  'category',
  'score',
  'holders',
  'tvl',
  'apy',
  'status',
] as const

export type VaultsTableColumn = (typeof vaultsTableColumns)[number]

export function isVaultsTableColumn(key: string): key is VaultsTableColumn {
  return vaultsTableColumns.includes(key as VaultsTableColumn)
}
